.root {
  overflow: auto;
  flex: 1;
}
